import React from 'react';
import INewsItem from '../../models/INewsItem';
import { DashBoardNewsItemContainer, NewsImage, NewsTitle } from './styled';

//Create react component with data prop type INewsItem with image, title, description, click link

const DashboardNewsItem = (props: { data: INewsItem }) => {
    const onClickNew = React.useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        window.open(props.data.link, "_blank")
    }, []);

    return (
        <DashBoardNewsItemContainer>
            <NewsImage src={props.data.image} onClick={onClickNew} />
            <NewsTitle>
                {props.data.title}
                <span className='newDescription' title={props.data.description}>{props.data.description}</span>
            </NewsTitle>
        </DashBoardNewsItemContainer>
    )
}
export default DashboardNewsItem;
